module.exports = __webpack_public_path__ + "img/CZK.83bcd24e.svg";